<template>
  <div class="drag-verify" :style="{display: showVerifyCode?'block':'none'}">
    <div class="behavior-captcha pop">
      <div class="slide-box">
        <div class="top-ctrl">
          <a class="ivu-modal-close" style="margin-top:10px" @click="closeDragCode">
            <i class="ivu-icon ivu-icon-ios-close"></i>
          </a>
          <div class="title">请完成安全验证</div>
        </div>
        <div class="content">
          <div class="display" :style="{width: width+'px',height:height+'px'}">
            <div class="loading-icon" v-if="loading">
              <i class="icon-l"></i>
              <div class="tip">加载中</div>
            </div>
            <div v-else>
              <div class="refresh rotate" @click="refresh"></div>
              <div class="bg" v-if="captcha.img">
                <img :src="captcha.img" />
              </div>
              <div
                ref="block"
                class="block"
                :style="{left: verify_block_x+'px', top: captcha.verify_block_y+'px'}"
                @mousedown="handleDragStart"
                @mousemove="handleDragMove"
                @mouseup="handleDragEnd"
                @touchstart="handleDragStart"
                @touchmove="handleDragMove"
                @touchend="handleDragEnd"
              >
                <img :src="captcha.slide_block_img" style="width: 50px;" />
              </div>
            </div>
          </div>
          <div class="control">
            <div :class="resultClass" class="bar">
              <div class="placeholder">{{resultText}}</div>
              <div
                ref="slideBlock"
                class="slide-block"
                :style="{left: verify_block_x+'px'}"
                @mousedown="handleDragStart"
                @mousemove="handleDragMove"
                @mouseup="handleDragEnd"
                @touchstart="handleDragStart"
                @touchmove="handleDragMove"
                @touchend="handleDragEnd"
              >
                <i class="zenticon zenticon-right icon custom-right"></i>
              </div>
              <div class="mask" :style="{width: verify_block_x+'px'}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DragVerify',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 350
    },
    height: {
      type: Number,
      default: 220
    }
  },
  data() {
    return {
      placeholder: '向右拖动滑块填充拼图',
      loading: true,
      showVerifyCode: this.value,
      token: '',
      verify_block_x: 0,
      verify_block_y: 0,
      captcha: {
        verify_block_y: 0,
        slide_block_img: '',
        img: ''
      },
      originX: undefined, //鼠标按下x坐标
      originY: undefined, //鼠标按下y坐标
      isMouseDown: false, //是否按下
      timestamp: null, //滑动时间
      verifyResult: undefined, //验证结果
      motion_locus: [], //动作轨迹
      oldTimestamp: 0 //滑动时间戳
    }
  },
  created() {
    this.bindEvents()
  },
  computed: {
    resultClass() {
      let classes = 'ready'
      if (this.loading) {
        classes = 'loading'
      } else if (this.verifyResult === false) {
        classes = 'failed'
      } else if (this.verifyResult === true) {
        classes = 'success'
      }
      return classes
    },
    resultText() {
      let text = this.placeholder
      if (this.loading) {
        text = '加载中'
      } else if (this.verifyResult === false) {
        text = '验证失败'
      } else if (this.verifyResult === true) {
        text = '验证成功'
      }
      return text
    }
  },
  methods: {
    bindEvents() {
      document.addEventListener('mousemove', this.handleDragMove)
      document.addEventListener('touchmove', this.handleDragMove)
      document.addEventListener('mouseup', this.handleDragEnd)
      document.addEventListener('touchend', this.handleDragEnd)
    },
    refresh() {
      this.reset()
      this.sliderGetCode()
      this.$emit('refresh')
    },
    closeDragCode() {
      this.showVerifyCode = false
      this.$emit('update:value', this.showVerifyCode)
      setTimeout(() => {
        this.reset()
      }, 1000)
    },
    //获取验证码
    sliderGetCode() {
      this.$api.slidergetcode().then(res => {
        if (res.code == 200) {
          this.loading = false
          this.captcha = res.response.captcha
          this.token = res.response.token
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    //验证验证码
    verifyCode() {
      let blockInfo = this.$refs.block
      let left = blockInfo.offsetLeft
      let top = blockInfo.offsetTop
      let right = left + blockInfo.offsetWidth
      let bottom = top + blockInfo.offsetHeight
      let parsms = {
        token: this.token,
        motion_locus: this.motion_locus,
        block_info: {
          left_top: {
            x: left,
            y: top
          }, //滑块左上角
          right_top: {
            x: right,
            y: top
          }, //滑块右上角
          left_bottom: {
            x: left,
            y: bottom
          }, //滑块左下角
          right_bottom: {
            x: right,
            y: bottom
          } //滑块右下角
        },
        time_consuming: `${(this.timestamp / 1000).toFixed(3)}`
      }
      console.log(parsms, '-----------parsms')
      this.$api.slidercheckcode(parsms).then(res => {
        if (res.code == 200) {
          this.verifyResult = res.response.result
          setTimeout(() => {
            if (this.verifyResult) {
              this.closeDragCode()
              this.$emit('success', res.response.ticket)
            } else {
              this.sliderGetCode()
              this.reset()
            }
          }, 1000)
        }
      })
    },
    // 重置验证码
    reset() {
      this.loading = true
      this.verify_block_x = 0
      this.timestamp = null
      this.verifyResult = undefined
      this.token = ''
      this.motion_locus = []
      this.oldTimestamp = 0
    },
    handleDragStart(e) {
      if (this.isMouseDown || this.loading === true) return
      this.originX = e.clientX || e.changedTouches[0].pageX
      this.originY = e.clientY || e.changedTouches[0].pageY
      this.isMouseDown = true
      this.timestamp = +new Date()
    },
    handleDragMove(e) {
      if (!this.isMouseDown || this.loading === true) return false
      // 滑动时间超过10秒 不让滑了
      if (+new Date() - this.timestamp > 1000 * 10) return false
      let eventX = e.clientX || e.changedTouches[0].pageX
      let eventY = e.clientY || e.changedTouches[0].pageY
      let moveX = eventX - this.originX
      let moveY = eventY - this.originY
      if (moveX < 0) {
        moveX = 0
      }
      if (moveX + 50 >= this.width) {
        moveX = this.width - 50
      }
      this.verify_block_x = moveX
      this.verify_block_y = moveY
      // console.log(new Date().getTime() - this.oldTimestamp);
      if (new Date().getTime() - this.oldTimestamp > 50) {
        this.oldTimestamp = new Date().getTime()
        this.motion_locus.push({
          block_position: {
            x: this.$refs.block.offsetLeft,
            y: this.$refs.block.offsetTop,
            time_stamp: new Date().getTime()
          }
        })
      }

      // console.log(this.motion_locus);
    },
    handleDragEnd(e) {
      if (!this.isMouseDown) return false
      this.isMouseDown = false
      let eventX = e.clientX || e.changedTouches[0].pageX
      if (eventX === this.originX) return false
      this.timestamp = +new Date() - this.timestamp
      this.oldTimestamp = 0
      this.verifyCode()
    }
  },
  mounted() {},
  watch: {
    value(val) {
      if (val) {
        this.showVerifyCode = val
        this.sliderGetCode()
      }
    }
  },
  destroyed() {
    window.removeEventListener('mousemove', this.handleDragMove, true)
    window.removeEventListener('touchmove', this.handleDragMove, true)
    window.removeEventListener('mouseup', this.handleDragEnd, true)
    window.removeEventListener('touchend', this.handleDragEnd, true)
  }
}
</script>
<style lang="css">
@import './drag-verify.css';
</style>
